'use strict';
/* ================================================================
   DRP Media — Product Customizer
   ATC code path audit:
     1. variantId read from hidden #variant-id input via parseInt() → always a Number
     2. POST /cart/add.js  body: JSON.stringify({ id: Number, quantity: Number, properties: Object })
     3. r.ok checked; Shopify description surfaced on failure
     4. Success: cart:updated event fires → global.js updates header count
   ================================================================ */
(function () {
  var cfg            = window.DRP_CUSTOMIZER || {};
  var MIDDLEWARE_URL = cfg.middlewareUrl || 'https://drp-media-production.up.railway.app';

  /* ── State ───────────────────────────────────────────────────── */
  var S = {
    mode:           'blank',
    method:         '',
    location:       '',
    locationKey:    '',
    printSize:      '',
    printSizeKey:   '',
    numColors:      1,            // Number of colours in design (Screen Printing / Vinyl)
    artworkUrl:     '',
    artworkFilename:'',
    copyright:      false,
    uploading:      false,
    atcLoading:     false,        // true while /cart/add.js is in-flight
    priceCents:     cfg.currentPriceCents || 0,
  };

  /* ── DOM refs ─────────────────────────────────────────────────
     variantIdEl    : hidden input in main-product.liquid  id="variant-id"
     qtyEl          : quantity input                       id="quantity"
     atcBtn         : primary ATC button                   id="customizer-atc-btn"
     stickyAtcBtn   : mobile sticky button                 id="customizer-sticky-atc-btn"
     atcErrorEl     : inline error paragraph               id="customizer-atc-error"
     methodWarningEl: inline warning for method            id="cust-method-warning"
     colorsFieldEl  : Number of Colors container           id="cust-colors-field"
     numColorsInput : Number input                         id="cust-num-colors"
     colorsHintEl   : hint text below colors field         id="cust-colors-hint"
  ──────────────────────────────────────────────────────────────── */
  var variantIdEl    = document.getElementById('variant-id');
  var qtyEl          = document.getElementById('quantity');
  var pricingEl      = document.getElementById('customizer-pricing-display');
  var custPanel      = document.getElementById('customizer-panel');
  var atcBtn         = document.getElementById('customizer-atc-btn');
  var stickyBar      = document.getElementById('customizer-sticky-bar');
  var stickyPrice    = document.getElementById('sticky-price');
  var stickyAtcBtn   = document.getElementById('customizer-sticky-atc-btn');
  var uploadZone     = document.getElementById('customizer-upload-zone');
  var fileInput      = document.getElementById('cust-file-input');
  var uploadIdle     = document.getElementById('cust-upload-idle');
  var uploadFileEl   = document.getElementById('cust-upload-file');
  var filenameEl     = document.getElementById('cust-filename-display');
  var removeFileBtn  = document.getElementById('cust-remove-file');
  var fileErrorEl    = document.getElementById('cust-file-error');
  var resWarningEl   = document.getElementById('cust-resolution-warning');
  var uploadProgress = document.getElementById('cust-upload-progress');
  var previewWrap    = document.getElementById('customizer-preview');
  var canvas         = document.getElementById('customizer-canvas');
  var copyrightCheck = document.getElementById('cust-copyright-check');
  var copyrightErrEl = document.getElementById('cust-copyright-error');
  var atcErrorEl     = document.getElementById('customizer-atc-error');
  var designersNote  = document.getElementById('cust-designers-note');
  var progressBar    = document.getElementById('cust-progress');
  var dragHint       = document.getElementById('cust-drag-hint');
  var previewActions = document.getElementById('cust-preview-actions');
  var resetBtn       = document.getElementById('cust-reset-position');
  /* ── New DOM refs ────────────────────────────────────────────── */
  var methodWarningEl = document.getElementById('cust-method-warning');
  var colorsFieldEl   = document.getElementById('cust-colors-field');
  var numColorsInput  = document.getElementById('cust-num-colors');
  var colorsHintEl    = document.getElementById('cust-colors-hint');
  var colorsMinus     = document.getElementById('cust-colors-minus');
  var colorsPlus      = document.getElementById('cust-colors-plus');
  var methodRecEl     = document.getElementById('cust-method-rec');
  var methodRecTextEl = document.getElementById('cust-method-rec-text');

  /* Minimum quantities per method (mirrors CustPricing.METHODS[x].minQty) */
  var METHOD_MIN_QTY = {
    'Screen Printing': 24,
    'DTF':              1,
    'Embroidery':      12,
    'Vinyl':            1,
  };

  /* ── Canvas preview init ─────────────────────────────────────── */
  if (canvas && window.CustPreview) {
    window.CustPreview.init(canvas);
    var mainImg = document.getElementById('product-main-img');
    if (mainImg && mainImg.src) {
      window.CustPreview.setBase(mainImg.src);
      if (typeof MutationObserver !== 'undefined') {
        new MutationObserver(function () {
          window.CustPreview.setBase(mainImg.src);
        }).observe(mainImg, { attributes: true, attributeFilter: ['src'] });
      }
    }
    /* Register position-change callback (drag ended) */
    if (typeof window.CustPreview.onPositionChange === 'function') {
      window.CustPreview.onPositionChange(function () { /* state updated via getPosition() at ATC */ });
    }
  }

  /* Reset Position button */
  if (resetBtn && window.CustPreview) {
    resetBtn.addEventListener('click', function () {
      window.CustPreview.resetPosition();
    });
  }

  /* ── Helpers ─────────────────────────────────────────────────── */
  function showErr(el, msg) {
    if (!el) return;
    el.textContent = msg;
    el.hidden = !msg;
  }

  function setStickyVisible(show) {
    if (!stickyBar) return;
    stickyBar.classList.toggle('is-visible', show);
    stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  /* Current qty from the DOM quantity input */
  function getQty() {
    return qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
  }

  /* Returns the formatted price for the given cent amount */
  function fmt(cents) {
    return window.CustPricing ? window.CustPricing.fmt(cents) : '';
  }

  /* Returns the total order price for the current customizer state */
  function getDisplayPrice() {
    if (!window.CustPricing) return S.priceCents;
    return window.CustPricing.getCustomizedPrice(
      S.priceCents,
      S.method,
      S.printSizeKey,
      getQty(),
      S.numColors
    );
  }

  /* Returns the ATC button label string (with live price appended) */
  function getAtcLabel() {
    var price;
    if (S.mode === 'customize') {
      price = getDisplayPrice();
    } else if (window.DRPSizeGrid && window.DRPSizeGrid.hasItems()) {
      price = window.DRPSizeGrid.getTotalCents();
    } else {
      price = S.priceCents;
    }
    var label    = S.mode === 'customize' ? 'Add Customized Item' : 'Add to Cart';
    var priceStr = fmt(price);
    return priceStr ? label + ' — ' + priceStr : label;
  }

  /* Apply .is-selected to the label wrapping a checked radio */
  function syncCardSelection(radioGroupSelector) {
    document.querySelectorAll(radioGroupSelector + ' label').forEach(function (lbl) {
      var inp = lbl.querySelector('input[type="radio"]');
      lbl.classList.toggle('is-selected', !!(inp && inp.checked));
    });
  }

  /* Update progress dot for a completed step */
  function markProgressDone(stepKey) {
    if (!progressBar) return;
    var dot = progressBar.querySelector('[data-progress-step="' + stepKey + '"]');
    if (dot) dot.classList.add('is-done');
  }

  /* ── Method recommendation banner ───────────────────────────── */
  function updateMethodRec() {
    if (!methodRecEl || S.mode !== 'customize') {
      if (methodRecEl) methodRecEl.hidden = true;
      return;
    }
    var qty = getQty();
    var text;
    if (qty === 1) {
      text = '💡 Recommended: Vinyl or Embroidery — best for single items';
    } else if (qty <= 11) {
      text = '💡 Recommended: Vinyl, Embroidery, or DTF — ideal for small runs';
    } else if (qty <= 23) {
      text = '💡 Recommended: DTF — best value for medium runs. Embroidery and Vinyl also available.';
    } else {
      text = '💡 Best value: Screen Printing — lowest per-unit cost at high volume. All methods available.';
    }
    if (methodRecTextEl) methodRecTextEl.textContent = text;
    methodRecEl.hidden = false;
  }

  /* ── Min-qty card enforcement ────────────────────────────────── */
  function updateMethodCards() {
    var qty = getQty();
    document.querySelectorAll('.cust-method-card').forEach(function (card) {
      var input = card.querySelector('input[type="radio"]');
      if (!input) return;
      var method = input.value;
      var minQty = METHOD_MIN_QTY[method] || 1;
      var belowMin = qty < minQty;

      card.classList.toggle('is-disabled', belowMin);
      input.disabled = belowMin;

      /* Add / update / remove min-qty badge */
      var badge = card.querySelector('.cust-method-card__min-badge');
      if (belowMin) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'cust-method-card__min-badge';
          card.appendChild(badge);
        }
        badge.textContent = 'Min. ' + minQty + ' units';
      } else if (badge) {
        badge.remove();
      }

      /* Auto-deselect if currently selected but now below min */
      if (belowMin && S.method === method) {
        S.method = '';
        input.checked = false;
        var stepVal = document.getElementById('step-method-val');
        if (stepVal) stepVal.textContent = '';
        var step = card.closest('.customizer-step');
        if (step) step.classList.remove('is-complete');
        syncCardSelection('.cust-method-cards');
        if (colorsFieldEl) colorsFieldEl.hidden = true;
        if (methodWarningEl) { methodWarningEl.hidden = true; methodWarningEl.textContent = ''; }
      }
    });
  }

  /* ── Method-specific warnings & conditional fields ───────────── */
  function updateMethodUI() {
    var method    = S.method;
    var qty       = getQty();
    var numColors = S.numColors;
    var warning   = '';

    /* Show Number of Colors field for Screen Printing and Vinyl */
    var needColors = (method === 'Screen Printing' || method === 'Vinyl');
    if (colorsFieldEl) colorsFieldEl.hidden = !needColors;

    /* Method-specific warnings */
    if (method === 'Screen Printing') {
      if (qty < 24) {
        warning = 'Screen printing requires a minimum of 24 units.';
      }
    } else if (method === 'Vinyl') {
      if (numColors > 4) {
        warning = 'Vinyl supports a maximum of 4 colors. Consider switching to DTF for designs with more colors.';
      } else {
        /* Proactive gradient note — always shown for Vinyl */
        warning = 'Vinyl does not support gradient designs. Consider DTF for full-colour prints.';
      }
    }

    if (methodWarningEl) {
      methodWarningEl.textContent = warning;
      methodWarningEl.hidden = !warning;
    }

    /* Colors hint text (screen printing: shows color sep fee) */
    if (colorsHintEl && window.CustPricing) {
      if (method === 'Screen Printing') {
        var colorFee = window.CustPricing.getColorFee(method, numColors);
        colorsHintEl.textContent = numColors + ' color' + (numColors === 1 ? '' : 's') + ' — color separation: ' + fmt(colorFee) + ' (one-time)';
      } else if (method === 'Vinyl') {
        colorsHintEl.textContent = numColors > 4
          ? 'Maximum 4 colors supported for vinyl.'
          : numColors + ' color' + (numColors === 1 ? '' : 's');
      } else {
        colorsHintEl.textContent = '';
      }
    }
  }

  /* ── Update / validate ───────────────────────────────────────── */
  function update() {
    var p   = S.priceCents;
    var qty = getQty();

    /* Recommendation banner + card enforcement (always runs in customize mode) */
    updateMethodRec();
    if (S.mode === 'customize') updateMethodCards();

    /* Pricing breakdown */
    if (window.CustPricing) {
      window.CustPricing.renderBreakdown(pricingEl, p, S.mode === 'customize', {
        method:    S.method,
        sizeKey:   S.printSizeKey,
        printSize: S.printSize,
        qty:       qty,
        numColors: S.numColors,
      });
      var displayCents = S.mode === 'customize' ? getDisplayPrice() : p;
      if (stickyPrice) stickyPrice.textContent = window.CustPricing.fmt(displayCents);
    }

    /* ATC eligibility */
    var ok;
    if (S.mode === 'blank') {
      /* With size grid: enabled when at least one size has qty > 0 */
      ok = window.DRPSizeGrid
        ? window.DRPSizeGrid.hasItems()
        : !!(variantIdEl && variantIdEl.value);
    } else {
      ok = !!(S.method && S.location && S.printSize && S.artworkUrl && S.copyright && !S.uploading);
    }

    /* Update button label + enabled state (only when not mid-flight) */
    if (!S.atcLoading) {
      var label = getAtcLabel();
      if (atcBtn) {
        atcBtn.disabled = !ok;
        atcBtn.textContent = label;
      }
      if (stickyAtcBtn) {
        stickyAtcBtn.disabled = !ok;
        stickyAtcBtn.textContent = S.mode === 'customize'
          ? (fmt(getDisplayPrice()) || 'Customize')
          : label;
      }
    }

    /* Copyright error hint */
    if (copyrightErrEl) {
      copyrightErrEl.hidden = !(S.mode === 'customize' && S.artworkUrl && !S.copyright);
    }

    /* Re-check method warnings (qty may have changed) */
    if (S.mode === 'customize' && S.method) updateMethodUI();
  }

  /* ── Mode toggle ─────────────────────────────────────────────── */
  document.querySelectorAll('[data-mode]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var newMode = btn.dataset.mode;
      if (newMode === S.mode) return;
      S.mode = newMode;
      document.querySelectorAll('[data-mode]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.mode === newMode ? 'true' : 'false');
      });
      if (custPanel) custPanel.hidden = newMode !== 'customize';
      if (progressBar) progressBar.hidden = newMode !== 'customize';
      setStickyVisible(true);
      showErr(atcErrorEl, '');
      if (newMode !== 'customize' && methodRecEl) methodRecEl.hidden = true;
      /* Tell main-product.liquid to show the right size UI */
      document.dispatchEvent(new CustomEvent('drp:mode:changed', { detail: { mode: newMode } }));
      update();
    });
  });

  /* Re-evaluate ATC eligibility whenever the size grid quantities change */
  document.addEventListener('drp:grid:changed', function () { update(); });

  /* Always show sticky bar on mobile */
  if (window.innerWidth < 768) setStickyVisible(true);

  /* ── Step accordion (mobile only) ───────────────────────────── */
  var allSteps = document.querySelectorAll('.customizer-step');
  document.querySelectorAll('.customizer-step__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var step = trigger.closest('.customizer-step');
      if (!step) return;
      var wasOpen = step.classList.contains('is-open');
      allSteps.forEach(function (s) {
        s.classList.remove('is-open');
        var t = s.querySelector('.customizer-step__trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        step.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ── Radio fields ────────────────────────────────────────────── */
  document.querySelectorAll('[data-customizer-field]').forEach(function (input) {
    /* Number inputs use 'input' event; radios use 'change' */
    var evtName = input.type === 'number' ? 'input' : 'change';

    input.addEventListener(evtName, function () {
      var field = input.getAttribute('data-customizer-field');

      if (field === 'method') {
        S.method = input.value;
        var el = document.getElementById('step-method-val');
        if (el) el.textContent = input.value;
        input.closest('.customizer-step').classList.add('is-complete');
        syncCardSelection('.cust-method-cards');
        markProgressDone('method');
        /* Reset colors to 1 when switching methods */
        S.numColors = 1;
        if (numColorsInput) numColorsInput.value = 1;
        updateMethodUI();

      } else if (field === 'location') {
        S.location    = input.value;
        S.locationKey = input.dataset.key ||
          input.value.toLowerCase().replace(/'/g, '').replace(/\s+/g, '_');
        var el = document.getElementById('step-location-val');
        if (el) el.textContent = input.value;
        input.closest('.customizer-step').classList.add('is-complete');
        syncCardSelection('.cust-location-grid');
        markProgressDone('location');
        if (window.CustPreview) window.CustPreview.setLocation(S.locationKey);
        // Designer's Choice: show note, hide interactive canvas & drag controls
        var isDesignersChoice = S.locationKey === 'designers_choice';
        if (designersNote) designersNote.hidden = !isDesignersChoice;
        if (canvas)         canvas.style.display       = isDesignersChoice ? 'none' : '';
        if (dragHint)       dragHint.hidden            = isDesignersChoice || !S.artworkUrl;
        if (previewActions) previewActions.hidden      = isDesignersChoice || !S.artworkUrl;

      } else if (field === 'size') {
        S.printSize    = input.value;
        S.printSizeKey = input.dataset.key ||
          input.value.split(' ')[0].toLowerCase();
        var el = document.getElementById('step-size-val');
        if (el) el.textContent = input.value;
        input.closest('.customizer-step').classList.add('is-complete');
        syncCardSelection('.cust-size-group');
        markProgressDone('size');
        if (window.CustPreview) window.CustPreview.setSize(S.printSizeKey);

      } else if (field === 'numColors') {
        var v = parseInt(input.value, 10) || 1;
        v = Math.max(1, Math.min(12, v));
        S.numColors = v;
        if (numColorsInput) numColorsInput.value = v;
        updateMethodUI();
      }

      update();
    });
  });

  /* Number of Colors stepper buttons */
  if (colorsMinus) {
    colorsMinus.addEventListener('click', function () {
      var v = Math.max(1, S.numColors - 1);
      S.numColors = v;
      if (numColorsInput) numColorsInput.value = v;
      updateMethodUI();
      update();
    });
  }
  if (colorsPlus) {
    colorsPlus.addEventListener('click', function () {
      var v = Math.min(12, S.numColors + 1);
      S.numColors = v;
      if (numColorsInput) numColorsInput.value = v;
      updateMethodUI();
      update();
    });
  }

  /* Quantity changes affect pricing (Screen Printing min-qty warning) */
  if (qtyEl) {
    qtyEl.addEventListener('change', function () { update(); });
    qtyEl.addEventListener('input',  function () { update(); });
  }

  /* ── File upload ─────────────────────────────────────────────── */
  function setFileError(msg)     { showErr(fileErrorEl, msg); }
  function setResWarning(show)   { if (resWarningEl) resWarningEl.hidden = !show; }

  function showUploadedState(filename) {
    if (uploadIdle)   uploadIdle.hidden   = true;
    if (uploadFileEl) uploadFileEl.hidden = false;
    if (filenameEl)   filenameEl.textContent = filename;
    if (uploadZone)   uploadZone.classList.add('has-file');
    var el = document.getElementById('step-upload-val');
    if (el) el.textContent = filename.length > 22 ? filename.slice(0, 20) + '…' : filename;
    var step = document.querySelector('[data-step="upload"]');
    if (step) step.classList.add('is-complete');
    markProgressDone('upload');
  }

  function clearUpload() {
    S.artworkUrl      = '';
    S.artworkFilename = '';
    if (uploadIdle)   uploadIdle.hidden   = false;
    if (uploadFileEl) uploadFileEl.hidden = true;
    if (uploadZone)   uploadZone.classList.remove('has-file');
    if (previewWrap)    previewWrap.hidden    = true;
    if (dragHint)       dragHint.hidden       = true;
    if (previewActions) previewActions.hidden = true;
    if (window.CustPreview) window.CustPreview.clear();
    var el = document.getElementById('step-upload-val');
    if (el) el.textContent = '';
    setFileError('');
    setResWarning(false);
    if (fileInput) fileInput.value = '';
    var step = document.querySelector('[data-step="upload"]');
    if (step) step.classList.remove('is-complete');
    if (progressBar) {
      var dot = progressBar.querySelector('[data-progress-step="upload"]');
      if (dot) dot.classList.remove('is-done');
    }
    update();
  }

  function validateFile(file) {
    var allowed = ['application/pdf', 'image/jpeg', 'image/png'];
    if (allowed.indexOf(file.type) === -1) {
      setFileError('Please upload a PDF, JPG, or PNG file.');
      return false;
    }
    if (file.size > 25 * 1024 * 1024) {
      setFileError('File must be under 25 MB.');
      return false;
    }
    setFileError('');
    return true;
  }

  function checkResolution(file) {
    if (file.type === 'application/pdf') return;
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      setResWarning(Math.min(img.naturalWidth, img.naturalHeight) < 1500);
      URL.revokeObjectURL(url);
    };
    img.src = url;
  }

  function handleFile(file) {
    if (!validateFile(file)) return;

    /* Require middleware — base64 inline is no longer allowed. */
    if (!MIDDLEWARE_URL) {
      setFileError('File upload is not configured. Contact the store admin.');
      return;
    }

    S.uploading = true;
    if (uploadProgress) uploadProgress.hidden = false;
    if (uploadZone)     uploadZone.classList.add('is-uploading');
    update();

    var reader = new FileReader();
    reader.onerror = function () {
      S.uploading = false;
      if (uploadProgress) uploadProgress.hidden = true;
      if (uploadZone)     uploadZone.classList.remove('is-uploading');
      setFileError('Failed to read the file. Please try again.');
      update();
    };

    /* All uploads go to middleware → receive CDN URL back */
    reader.onload = function (e) {
      var dataUrl = e.target.result;
      var b64     = dataUrl.split(',')[1];
      fetch(MIDDLEWARE_URL + '/artwork-uploads', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ filename: file.name, mimeType: file.type, data: b64 }),
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.error || 'Upload failed'); });
          return r.json();
        })
        .then(function (json) {
          S.artworkUrl      = json.url;       // CDN URL — short string, safe for cart properties
          S.artworkFilename = json.filename;
          S.uploading       = false;
          if (uploadProgress) uploadProgress.hidden = true;
          if (uploadZone)     uploadZone.classList.remove('is-uploading');
          showUploadedState(json.filename);
          if (canvas && previewWrap && window.CustPreview) {
            previewWrap.hidden = false;
            var isDesignersChoice = S.locationKey === 'designers_choice';
            if (canvas)         canvas.style.display  = isDesignersChoice ? 'none' : '';
            if (dragHint)       dragHint.hidden        = isDesignersChoice;
            if (previewActions) previewActions.hidden  = isDesignersChoice;
            window.CustPreview.setArtwork(dataUrl); // local blob for instant preview
          }
          checkResolution(file);
          update();
        })
        .catch(function (err) {
          S.uploading = false;
          if (uploadProgress) uploadProgress.hidden = true;
          if (uploadZone)     uploadZone.classList.remove('is-uploading');
          setFileError('Upload failed: ' + err.message + '. Please try again or contact support.');
          update();
        });
    };
    reader.readAsDataURL(file);
  }

  if (fileInput) {
    fileInput.addEventListener('change', function () {
      if (fileInput.files[0]) handleFile(fileInput.files[0]);
    });
  }

  if (uploadZone) {
    uploadZone.addEventListener('click', function (e) {
      if (!e.target.closest('#cust-upload-file') &&
          !e.target.closest('#cust-upload-progress')) {
        if (fileInput) fileInput.click();
      }
    });
    uploadZone.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (fileInput) fileInput.click();
      }
    });
    uploadZone.addEventListener('dragover', function (e) {
      e.preventDefault();
      uploadZone.classList.add('is-drag-over');
    });
    uploadZone.addEventListener('dragleave', function () {
      uploadZone.classList.remove('is-drag-over');
    });
    uploadZone.addEventListener('drop', function (e) {
      e.preventDefault();
      uploadZone.classList.remove('is-drag-over');
      var file = e.dataTransfer && e.dataTransfer.files[0];
      if (file) handleFile(file);
    });
  }

  if (removeFileBtn) {
    removeFileBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      clearUpload();
    });
  }

  /* ── Copyright ───────────────────────────────────────────────── */
  if (copyrightCheck) {
    copyrightCheck.addEventListener('change', function () {
      S.copyright = copyrightCheck.checked;
      if (S.copyright) markProgressDone('copyright');
      else if (progressBar) {
        var dot = progressBar.querySelector('[data-progress-step="copyright"]');
        if (dot) dot.classList.remove('is-done');
      }
      update();
    });
  }

  /* ── Variant price tracking ──────────────────────────────────── */
  document.addEventListener('drp:variant:changed', function (e) {
    if (e.detail && typeof e.detail.priceCents === 'number') {
      S.priceCents = e.detail.priceCents;
      update();
    }
  });

  /* ── Add to Cart ─────────────────────────────────────────────────
     PAYLOAD VERIFIED:
       id       : parseInt(input.value, 10)  → always a Number (Shopify requires Number)
       quantity : parseInt(input.value, 10)  → always a Number
       properties: Object of string values   → JSON.stringify handles " in values correctly
       Content-Type: application/json        → required for JSON body
  ────────────────────────────────────────────────────────────────── */


  /* ── Mockup capture helper ────────────────────────────────────────────
     Snapshot the canvas (product image + positioned artwork overlay) and
     upload it to the middleware. Returns a Promise<string|null> — the CDN
     URL of the uploaded mockup PNG, or null if capture/upload failed.
     Failure is always silent so Add to Cart is never blocked.
  ──────────────────────────────────────────────────────────────────── */
  function _captureMockup(variantId) {
    if (!canvas || !MIDDLEWARE_URL || S.mode !== 'customize' || !S.artworkUrl) {
      console.log('[mockup] skipping capture — missing canvas/middleware/artwork or wrong mode');
      return Promise.resolve(null);
    }
    var dataUrl;
    try {
      dataUrl = canvas.toDataURL('image/png');
      console.log('[mockup] canvas export success, size:', dataUrl.length);
    } catch (e) {
      // Canvas is tainted by a cross-origin image that was served without CORS headers.
      // The base image is loaded with crossOrigin='anonymous' + cache-bust, so this
      // should only happen on CDN configs that don't send Access-Control-Allow-Origin.
      // ATC is NOT blocked — we just skip the mockup and fall back to stored coordinates.
      console.error('[mockup] canvas export failed (CORS — CDN may not send CORS headers):', e.message);
      return Promise.resolve(null);
    }
    var b64 = dataUrl.split(',')[1];
    if (!b64) return Promise.resolve(null);
    return fetch(MIDDLEWARE_URL + '/artwork-uploads', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({
        filename: 'mockup-' + variantId + '-' + Date.now() + '.png',
        mimeType: 'image/png',
        data:     b64,
      }),
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var url = (j && j.url) ? j.url : null;
        console.log('[mockup] uploaded to CDN:', url);
        return url;
      })
      .catch(function (err) {
        console.warn('[mockup] upload failed (non-blocking):', err && err.message);
        return null;
      });
  }

  function doAddToCart() {
    showErr(atcErrorEl, '');

    /* ─ 0. Blank mode with size grid: multi-item add ─────────────
       When the size quantity grid is active, we POST an `items` array
       so every size goes in as its own line item in one request.
    ─────────────────────────────────────────────────────────────── */
    if (S.mode === 'blank' && window.DRPSizeGrid && window.DRPSizeGrid.hasItems()) {
      var gridItems = window.DRPSizeGrid.getCartItems();
      S.atcLoading = true;
      [atcBtn, stickyAtcBtn].forEach(function (b) {
        if (!b) return;
        b.dataset.origText = b.textContent.trim();
        b.disabled = true;
        b.classList.add('is-loading');
        b.textContent = 'Adding';
      });
      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body:    JSON.stringify({ items: gridItems }),
      })
      .then(function (r) {
        if (!r.ok) {
          return r.json()
            .catch(function () { throw new Error('Server error (' + r.status + ').'); })
            .then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart.'); });
        }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        S.atcLoading = false;
        showErr(atcErrorEl, '');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: cart.item_count } }));
        [atcBtn, stickyAtcBtn].forEach(function (b) {
          if (!b) return;
          b.classList.remove('is-loading');
          b.classList.add('is-success');
          b.textContent = 'Added ✓';
          b.disabled = false;
        });
        setTimeout(function () {
          [atcBtn, stickyAtcBtn].forEach(function (b) {
            if (!b) return;
            b.classList.remove('is-success');
          });
          update();
        }, 2000);
      })
      .catch(function (err) {
        S.atcLoading = false;
        showErr(atcErrorEl, (err && err.message) ? err.message : 'Could not add to cart.');
        [atcBtn, stickyAtcBtn].forEach(function (b) {
          if (!b) return;
          b.classList.remove('is-loading', 'is-success');
          b.textContent = b.dataset.origText || 'Add to Cart';
          b.disabled = false;
        });
        update();
      });
      return;
    }

    /* ─ 1. Read variant ID from the DOM hidden input ─────────────
       The input lives in main-product.liquid:
         <input type="hidden" id="variant-id" value="{{ current_variant.id }}">
       parseInt ensures this is ALWAYS a Number, never a string.
    ─────────────────────────────────────────────────────────────── */
    var variantId = variantIdEl ? parseInt(variantIdEl.value, 10) : 0;

    console.log('[customizer] doAddToCart', {
      mode: S.mode,
      variantIdEl: !!variantIdEl,
      variantId: variantId,
      variantValue: variantIdEl ? variantIdEl.value : null,
      method: S.method, location: S.location,
      printSize: S.printSize,
      numColors: S.numColors,
      artworkSet: !!S.artworkUrl,
      artworkIsDataUrl: S.artworkUrl ? S.artworkUrl.indexOf('data:') === 0 : false,
      artworkLen: S.artworkUrl ? S.artworkUrl.length : 0,
      copyright: S.copyright,
    });

    if (!variantId) {
      showErr(atcErrorEl, 'Please select a size and colour before adding to cart.');
      return;
    }

    var qty = getQty();

    /* ─ 2. Copyright guard (customize mode only) ─────────────── */
    if (S.mode === 'customize' && !S.copyright) {
      if (copyrightErrEl) {
        copyrightErrEl.hidden = false;
        copyrightErrEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    /* ─ 3. Artwork upload guard ───────────────────────────────── */
    // Artwork is always a CDN URL now; a data: URL means an upload is still in
    // progress or something went wrong — block checkout until it resolves.
    if (S.mode === 'customize' &&
        S.artworkUrl &&
        S.artworkUrl.indexOf('data:') === 0) {
      showErr(atcErrorEl,
        'Your artwork is still uploading. Please wait a moment, then try again.');
      return;
    }

    /* ─ 4. Pre-build the cart properties (mockup URL filled in later) ──── */
    var pos = (window.CustPreview && typeof window.CustPreview.getPosition === 'function')
      ? window.CustPreview.getPosition()
      : { x: '0.500', y: '0.350', scale: '1.000' };

    /* ─ 5. Loading state ─────────────────────────────────────── */
    S.atcLoading = true;
    [atcBtn, stickyAtcBtn].forEach(function (b) {
      if (!b) return;
      b.dataset.origText = b.textContent.trim();
      b.disabled = true;
      b.classList.add('is-loading');
      b.textContent = 'Adding';
    });

    /* ─ 6. Capture mockup → upload → POST to cart ───────────────
       _captureMockup() is best-effort: any failure (CORS, network,
       no artwork yet) resolves to null so ATC is never blocked.
    ─────────────────────────────────────────────────────────────── */
    _captureMockup(variantId)
      .then(function (mockupUrl) {
        var payload = {
          id:       variantId,
          quantity: qty,
        };
        if (S.mode === 'customize') {
          /* Pricing breakdown (all amounts in cents, stored as strings per Shopify spec) */
          var printFeePerUnit = window.CustPricing
            ? window.CustPricing.getPrintFeePerUnit(S.method, S.printSizeKey)
            : 0;
          var setupFee = window.CustPricing
            ? window.CustPricing.getSetupFee(S.method)
            : 0;
          var colorFee = window.CustPricing
            ? window.CustPricing.getColorFee(S.method, S.numColors)
            : 0;

          payload.properties = {
            'Print Method':           S.method,
            'Print Location':         S.location,
            'Print Size':             S.printSize,
            'Number of Colors':       String(S.numColors),
            '_setup_fee':             String(setupFee),
            '_color_fee':             String(colorFee),
            '_print_fee_per_unit':    String(printFeePerUnit),
            '_quantity':              String(qty),
            '_artwork_url':           S.artworkUrl,
            '_artwork_filename':      S.artworkFilename || '',
            '_artwork_x':             pos.x,
            '_artwork_y':             pos.y,
            '_artwork_scale':         pos.scale,
            '_mockup_url':            mockupUrl || '',
            '_copyright_accepted':    'true',
            '_copyright_accepted_at': new Date().toISOString(),
          };
        }
        var bodyStr = JSON.stringify(payload);
        console.log('[customizer] POST /cart/add.js', {
          variantId: payload.id, quantity: payload.quantity,
          hasProperties: !!payload.properties,
          hasMockup: !!mockupUrl, bodySize: bodyStr.length,
        });
        return fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body:    bodyStr,
        });
      })
      /* ─ 7. Check response — surface Shopify's own description ─ */
      .then(function (r) {
        if (!r.ok) {
          return r.json()
            .catch(function () {
              throw new Error('Server error (' + r.status + '). Please try again.');
            })
            .then(function (j) {
              throw new Error(j.description || j.message || 'Could not add to cart.');
            });
        }
        return r.json();
      })
      /* ─ 8. Re-fetch cart to get up-to-date item count ──────── */
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      /* ─ 9. Success ─────────────────────────────────────────── */
      .then(function (cart) {
        console.log('[customizer] cart add success, item_count =', cart.item_count);
        S.atcLoading = false;
        showErr(atcErrorEl, '');
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { count: cart.item_count },
        }));
        [atcBtn, stickyAtcBtn].forEach(function (b) {
          if (!b) return;
          b.classList.remove('is-loading');
          b.classList.add('is-success');
          b.textContent = 'Added ✓';
          b.disabled = false;
        });
        setTimeout(function () {
          [atcBtn, stickyAtcBtn].forEach(function (b) {
            if (!b) return;
            b.classList.remove('is-success');
          });
          update(); // restores correct label + disabled state
        }, 2000);
      })
      /* ─ 10. Error ───────────────────────────────────────────── */
      .catch(function (err) {
        console.error('[customizer] Add to cart error:', err);
        S.atcLoading = false;
        var msg = (err && err.message)
          ? err.message
          : 'Could not add to cart. Please try again.';
        showErr(atcErrorEl, msg);
        [atcBtn, stickyAtcBtn].forEach(function (b) {
          if (!b) return;
          b.classList.remove('is-loading', 'is-success');
          b.textContent = b.dataset.origText || 'Add to Cart';
          b.disabled = false;
        });
        update();
      });
  }

  if (atcBtn)      atcBtn.addEventListener('click', doAddToCart);
  if (stickyAtcBtn) stickyAtcBtn.addEventListener('click', doAddToCart);

  /* ── Initial render ──────────────────────────────────────────── */
  update();

  /* ── Startup diagnostics (remove before go-live) ─────────────── */
  console.log('[customizer] init', {
    atcBtn:        !!atcBtn,
    stickyAtcBtn:  !!stickyAtcBtn,
    variantIdEl:   !!variantIdEl,
    variantId:     variantIdEl ? variantIdEl.value : '(element missing — check main-product.liquid)',
    atcErrorEl:    !!atcErrorEl,
    mode:          S.mode,
    priceCents:    S.priceCents,
  });

})();
